import {invoiceTranslations} from "./invoice";
import {currencyTranslations} from "./currency";
import {companySettingsTranslations} from "./company_settings";
import {employeeTranslations} from "./employee";
// noinspection JSNonASCIINames,NonAsciiCharacters

export const etTranslations = {
    common: {
        back: "Tagasi",
        next: "Edasi",
        open: "Ava",
        close: "Sulge",
        clear: "Kustuta",
        delete_short: "Puhasta.",
        delete: "Kustuta",
        send: "Saada",
        save: "Salvesta",
        add: "Lisa",
        cancel: "Tühista",
        preview: "Eelvaade",
        are_you_sure: "Olete kindel?",
        dropzone: "Lohistage siia fail või klõpsake lihtsalt",
        upload: "Laadi üles",
        notify: "Teavita",
        here: "siin",
        yes: "Jah",
        no: "Ei",
        uom: {
            "months": "kuud",
            "pcs": "tk.",
            "hours": "tunni",
            "km": "km.",
            "kg": "kg.",
            "m³": "m³",
            "m²": "m²",
            "ltr": "liiter",
            "N/A": "N/A",
        },
        article: {
            "Sale of goods in Estonia or non EU": "Kaupade müük Eestis või väljaspool EL-i",
            "Sale of services in Estonia or non EU": "Teenuste müük Eestis või väljaspool EL-i",
            "Sale of goods in Estonia or non EU after 01.07.2025": "Kaupade müük Eestis või väljaspool EL-i pärast 01.07.2025",
            "Sale of services in Estonia or non EU after 01.07.2025": "Teenuste müük Eestis või väljaspool EL-i pärast 01.07.2025",
            "Sale of goods in the EU 0%": "Kaupade müük EL-is 0%",
            "Sale of services in the EU 0%": "Teenuste müük EL-is 0%",
            "Export of goods from Estonia": "Kaupade eksport Eestist",
            "select_correct_article": "Palun valige õige artikkel",
        },
        tax: {},
        error: {
            required_field: "Kohustuslik väli",
            invalid_email: "Vigane e-posti aadress",
            invalid_email_with_address: "'{{email}}' on vigane e-posti aadress",
            should_be_greater_that_zero: "Peab olema suurem kui null",
        }
    },
    user_menu: {
        "Subscription": "Tellimus",
        "Language": "Keel/Lang",
        "Logout": "Logi välja",
        "CompanySettings": "Ettevõtte seaded",
    },
    nav_bar: {
        company_selector: "Valige ettevõte",
        "Upload docs": "Laadi dokumendid üles",
        "Sales": "Müük",
        "New invoice": "Uus arve",
        "My sales": "Minu müük",
        "My clients": "Minu kliendid",
        "My company": "Minu ettevõtte",
        "Details": "Üksikasjad",
        "Advice": "Nõu",
        "Knowledge base": "Teadmisbaas",
        "Employees": "Töötajad",
        "New employee": "Uus töötaja",
        "Links": "Lingid",
        "Templates": "Dokumentide näidised",
    },
    documents: {
        upload: {
            time_frame: "Periood",
            time_frame_hint: "Palun valige kuu ja aasta, mille jaoks laadite dokumendid üles",
            files: {
                header: "Failid",
                title: "Palun laadige üles järgmised dokumendid:",
                sales_invoices: "Müügiarved <1>PDF</1> formaadis, kui te ei kasuta meie arve genereerijat",
                purchase_invoices: "Ostu arved ja tšekid <1>PDF</1> formaadis",
                statements: "Panga väljavõtted, <1>kui te pole meile juurdepääsu andnud</1>",
                statements_est_banks: "formaadis <1><2>XML</2></1> и <3><4>PDF</4></3>,kui kasutate Eesti pankade teenuseid",
                statements_other_banks: "formaadis,<1><2>CSV</2></1> и <3><4>PDF</4></3>, kui kasutate TransferWise, EuroWallet, Revolut, PaySera, PayPal või teisi maksesüsteeme",
            },
            review: {
                header: "Ülevaade",
                period_summary: "Laadin dokumendid üles ajavahemiku jaoks",
                rejected_documents: "Dokumendid, mida ei laadita üles:",
                documents_to_upload: "Dokumentide nimekiri:",
                comment_label: "Kommentaar raamatupidajale (pole kohustuslik)",
                comment_placeholder: "Palun jätke kommentaar seoses üleslaaditavate dokumentidega",
            },
            upload: {
                header: "Üleslaadimine",
                success: "Kõik failid on edukalt üles laaditud!",
                error: "Faili ei õnnestunud üles laadida, palun pöörduge klienditoe poole!",
            }
        }
    },
    loader_screen: {
        select_company: "Palun valige esmalt ettevõte",
        no_company_assigned: "Ühtegi ettevõtet pole teie kontoga seotud",
        no_company_action: "Kui teil on küsimusi meie teenuste kohta, kasutage paremas nurgas asuvat jututuba ja me võtame teiega ühendust esimesel võimalusel",
    },
    advice: {
        use_chat: "Kui teil on küsimusi, kasutage paremas nurgas olevat jutunuppu",
    },
    my_company_info: {
        header: "Teie ettevõtte üldinfo",
        "Company name": "Ettevõtte nimi",
        "Reg. code": "Reg. kood",
        "VAT number": "KMKR number",
        "Legal address": "Juriidiline aadress",
        "mailbox_address_note": "Kui soovite oma ettevõtte nimel kirju vastu võtta, kasutage palun allpool toodud postiaadressi",
        "Mailbox address": "Postiaadress",
    },
    knowledge_base: {
        header: "Teadmisbaas",
        sub_header: "Oleme teile ette valmistanud laia valiku artikleid, mis kirjeldavad erinevaid Eesti raamatupidamise aspekte",
        visit_knowledge_base: "Kui teil on küsimusi, vaadake, kas vastus on meie teadmiste andmebaasis",
        here: "siin",
        link: "https://help.amsgroup.ee/",
        ask_advice: "Kui teil on veel küsimusi, võtke meiega ühendust chati kaudu",
    },
    client_docs_templates: {
        header: "Dokumentide näidised",
    },
    customers_list: {
        title: "Kliendid",
        name: "Nimi",
        address: "Aadress",
        city: "Linn",
        post_code: "Sihtnumber",
        country: "Riik",
    },
    edit_customer: {
        edit_header: "Kliendi muutmine",
        add_header: "Lisa klient",
        name: {
            label: "Nimi",
            placeholder: "Täisnimi",
            helper_text: "Ettevõtte nimi või füüsilise isiku täisnimi",
        },
        not_td_customer: "Füüsiline isik või ettevõte, mis on registreeritud väljaspool Eestit",
        reg_num: {
            label: "Reg. number",
            placeholder: "Registreerimisnumber",
        },
        vat_num: {
            label: "KMKR number",
            placeholder: "KMKR number",
        },
        address: {
            label: "Aadress",
            placeholder: "Aadress",
            helper_text: "Aadressi rida (tänav, maja number jne.)",
        },
        city: "Linn",
        postal_code: "Postiindeks",
        country: "Riik",
        email: "E-post",
        phone_num: "Telefon",
        currency: "Valuuta",
        inv_lang: "Arve keel",
        payment_dead_line: {
            label: "Maksetähtaeg",
            placeholder: "Maksetähtaeg",
            helper_text: "Päevade arv, mille jooksul klient peab arve tasuma",
        },
        overdue_charge: {
            label: "Viivise %",
            placeholder: "Viivise %",
            helper_text: "Hilineva võla protsent",
        },
    },
    m_table: {
        "Add or remove columns": "Lisa või eemalda veerge",
        "{0} row(s) selected": "rida(valitud) {0}",
        "Search": "Otsing",
        "First Page": "Esimene leht",
        "Previous Page": "Eelmine leht",
        "Next Page": "Järgmine leht",
        "Last Page": "Viimane leht",
        "{from}-{to} of {count}": "{from}-{to} kokku {count}-st",
        "Rows per page": "Ridu lehe kohta",
        "rows": "rida",
        "No records to display": "Pole kirjeid kuvamiseks",
        "Actions": "Tegevused",
    },
    ...invoiceTranslations,
    ...employeeTranslations,
    ...currencyTranslations,
    ...companySettingsTranslations,
}